import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid gap-3 sm:grid-cols-1" }

import { InputRow } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';
    import { Textarea } from '@/components/ui/textarea';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BIReportForm',
  props: {
    form: {}
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "reporting_account",
      label: "bi_and_companies.reporting_account"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Input), {
          id: "reporting_account",
          modelValue: _ctx.form.reporting_account,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.reporting_account) = $event)),
          placeholder: _ctx.$t('bi_and_companies.reporting_account')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "reporting_account_nr",
      label: "bi_and_companies.reporting_account_nr"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Input), {
          id: "number",
          modelValue: _ctx.form.reporting_account_nr,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.reporting_account_nr) = $event)),
          placeholder: _ctx.$t('bi_and_companies.reporting_account_nr')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "account_mapping",
      label: "bi_and_companies.account_mapping"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Textarea), {
          id: "account_mapping",
          modelValue: _ctx.form.account_mapping,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.account_mapping) = $event)),
          placeholder: _ctx.$t('bi_and_companies.account_mapping')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "measurement_calculation",
      label: "bi_and_companies.measurement_calculation"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Input), {
          id: "measurement_calculation",
          modelValue: _ctx.form.measurement_calculation,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.measurement_calculation) = $event)),
          placeholder: _ctx.$t('bi_and_companies.measurement_calculation')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"])
  ]))
}
}

})